export const PUSH_EVENT = 'PUSH_EVENT'
export const RESET_STATE = 'RESET_STATE'
